import React, { useEffect, useState } from 'react';
import Sidebar from '../Components/Sidebar';
import MobileNav from '../Components/MobileNav'; // ADD THIS
import { useIsMobile } from '../hooks/useMediaQuery'; // ADD THIS
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Loader from '../Components/Loader';
import { useLanguage } from '../context/LanguageContext';

export default function Players() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const isMobile = useIsMobile(); // ADD THIS
  
  const [collapsed, setCollapsed] = useState(false);
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    getCurrentUser();
  }, []);

  const getCurrentUser = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    setCurrentUser(user);
    if (user) {
      fetchPlayers(user.id);
    }
  };

  const fetchPlayers = async (currentUserId) => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('igd')
        .select('*')
        .neq('user_id', currentUserId);

      if (!error) {
        setPlayers(data);
        setTotalCount(data.length);
      } else {
        console.error('Error fetching players:', error);
      }
    } catch (err) {
      console.error(err.message);
    }
    setLoading(false);
  };

  const filteredPlayers = players.filter(player =>
    player.avatarName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    player.clan?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        background: 'var(--bg)', 
        minHeight: '100vh',
        flexDirection: isMobile ? 'column' : 'row',
      }}>
        {!isMobile && <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />}
        <div style={{ 
          flex: 1, 
          marginLeft: isMobile ? '0' : (collapsed ? '80px' : '280px'),
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          padding: isMobile ? '20px' : '0',
        }}>
          <Loader size={isMobile ? 80 : 120} />
        </div>
        {isMobile && <MobileNav />}
      </div>
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      background: 'var(--bg)', 
      minHeight: '100vh',
      flexDirection: isMobile ? 'column' : 'row',
    }}>
      {!isMobile && <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />}

      <div style={{ 
        flex: 1, 
        marginLeft: isMobile ? '0' : (collapsed ? '80px' : '280px'),
        padding: isMobile ? '16px' : '40px', 
        color: 'var(--text)',
        transition: 'margin-left 0.3s ease',
        overflowX: 'hidden',
        paddingBottom: isMobile ? '90px' : '40px',
      }}>
        {/* Header with count */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: isMobile ? '20px' : '30px',
          flexWrap: 'wrap',
          gap: isMobile ? '12px' : '20px',
          flexDirection: isMobile ? 'column' : 'row',
        }}>
          <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
            <h1 style={{ 
              fontSize: isMobile ? '24px' : '32px', 
              marginBottom: isMobile ? '4px' : '5px',
            }}>
              {t('players')}
            </h1>
            <p style={{ 
              color: '#64748b',
              fontSize: isMobile ? '13px' : '14px',
            }}>
              {totalCount} {t('totalPlayers').toLowerCase()}
            </p>
          </div>

          {/* Search Bar */}
          <div style={{ 
            position: 'relative', 
            width: isMobile ? '100%' : '300px',
            maxWidth: '400px',
          }}>
            <input
              type="text"
              placeholder={t('search') + "..."}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: '100%',
                padding: isMobile ? '12px 16px 12px 44px' : '12px 20px 12px 45px',
                borderRadius: '9999px',
                border: '1px solid var(--border)',
                background: 'var(--input-bg)',
                color: 'var(--text)',
                fontSize: '16px', // Prevents iOS zoom
                outline: 'none',
                minHeight: '48px', // Touch target
                boxSizing: 'border-box',
              }}
            />
            <span style={{ 
              position: 'absolute', 
              left: isMobile ? '14px' : '15px', 
              top: '50%', 
              transform: 'translateY(-50%)',
              fontSize: isMobile ? '16px' : '18px',
            }}>
              🔍
            </span>
          </div>
        </div>

        {/* Players Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(250px, 1fr))',
          gap: isMobile ? '12px' : '20px',
        }}>
          {filteredPlayers.map(player => (
            <div
              key={player.id}
              onClick={() => navigate(`/players/${player.user_id}`)}
              style={{
                background: 'var(--card-bg)',
                padding: isMobile ? '16px' : '25px',
                borderRadius: isMobile ? '12px' : '16px',
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s',
                border: '1px solid var(--border)',
                position: 'relative',
                overflow: 'hidden',
                minHeight: isMobile ? '160px' : 'auto',
              }}
              onMouseEnter={e => {
                if (!isMobile) {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(56, 189, 248, 0.2)';
                }
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              
              <img
                src={player.avatar_url || "https://i.pravatar.cc/150"}
                alt={player.avatarName}
                style={{
                  width: isMobile ? '60px' : '100px',
                  height: isMobile ? '60px' : '100px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: isMobile ? '2px solid #38bdf8' : '3px solid #38bdf8',
                  marginBottom: isMobile ? '10px' : '15px',
                }}
              />
              <h3 style={{ 
                marginBottom: isMobile ? '4px' : '5px', 
                fontSize: isMobile ? '14px' : '18px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }} title={player.avatarName || 'Unknown'}>
                {player.avatarName || 'Unknown'}
              </h3>
              <p style={{ 
                fontSize: isMobile ? '12px' : '14px', 
                color: '#64748b', 
                marginBottom: isMobile ? '4px' : '5px',
              }}>
                {player.rank || 'Unranked'}
              </p>
              {player.clan && (
                <span style={{
                  display: 'inline-block',
                  padding: isMobile ? '3px 10px' : '4px 12px',
                  background: 'rgba(56, 189, 248, 0.1)',
                  color: '#38bdf8',
                  borderRadius: '9999px',
                  fontSize: isMobile ? '10px' : '12px',
                  fontWeight: 'bold',
                  maxWidth: '100%',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }} title={player.clan}>
                  {player.clan}
                </span>
              )}
            </div>
          ))}
        </div>

        {filteredPlayers.length === 0 && (
          <div style={{ 
            textAlign: 'center', 
            padding: isMobile ? '40px 20px' : '60px', 
            color: '#64748b',
          }}>
            <p style={{ fontSize: isMobile ? '14px' : '16px' }}>
              No players found matching "{searchQuery}"
            </p>
          </div>
        )}
      </div>
      
      {isMobile && <MobileNav />}
    </div>
  );
}